let hardwareWebGL: boolean | undefined;

/* The renderer names browsers report when WebGL is drawn on the CPU: Chrome's SwiftShader, Mesa's llvmpipe and softpipe, Windows' WARP. */
const SOFTWARE_RENDERER = /swiftshader|llvmpipe|softpipe|basic render|software/i;

/*
 * Whether the browser can draw WebGL on a GPU. Without one (a machine with no graphics acceleration, a remote
 * desktop, a CI runner, an audit tool such as Lighthouse or PageSpeed Insights) the browser falls back to drawing
 * on the CPU, and the 3D hero would take the whole page with it. Two signals, because browsers differ in which
 * they give: failIfMajorPerformanceCaveat makes a browser refuse the context, and the unmasked renderer name says
 * SwiftShader or llvmpipe when it did not. Asked once; the probe context is released straight away.
 */
export function hasHardwareWebGL(): boolean {
    if (hardwareWebGL === undefined) {
        try {
            const gl = document.createElement('canvas').getContext('webgl2', { failIfMajorPerformanceCaveat: true });
            const info = gl?.getExtension('WEBGL_debug_renderer_info');
            const renderer = gl && info ? String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL)) : '';
            hardwareWebGL = Boolean(gl) && !SOFTWARE_RENDERER.test(renderer);
            gl?.getExtension('WEBGL_lose_context')?.loseContext();
        } catch {
            hardwareWebGL = false;
        }
    }
    return hardwareWebGL;
}
